import {firebaseEnvironment} from "./firebase.environment";

export const environment = {
  production: true,
  firebase: firebaseEnvironment,
  version: '0.5.58'
};
